import React, { useState } from 'react';
import { stripHtml } from '../adminAyarlar/shared/utils';

const EventsMenu = ({ events = [], selectedEvent, onSelectEvent, categories = [] }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [showCategoryFilter, setShowCategoryFilter] = useState(false);

  // Filter events based on search term and category
  const filteredEvents = events.filter(event => {
    const matchesSearch = !searchTerm || 
      event.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      event.description?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesCategory = !selectedCategory || 
      event.category_id?._id === selectedCategory ||
      event.category_id === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  return (
    <div className="p-4 h-full flex flex-col overflow-hidden">
      <div className="flex-shrink-0 mb-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">Olaylar</h2>
          
          {/* Filter Button */}
          <button
            onClick={() => setShowCategoryFilter(!showCategoryFilter)}
            className={`p-2 rounded-lg shadow hover:bg-gray-50 transition-colors ${
              selectedCategory ? 'bg-blue-100 text-blue-600' : 'bg-white'
            }`}
            title="Kategori Filtresi"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
            </svg>
          </button>
        </div>
        
        {/* Search Input */}
        <div className="mb-3">
          <input
            type="text"
            placeholder="Olay ara..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Category Filter - Inline Position */}
        {showCategoryFilter && categories.length > 0 && (
          <div className="mb-3 bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden relative z-10 max-h-96">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex items-center space-x-2">
                <div className="p-1.5 bg-blue-100 rounded-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-gray-800">Kategori Filtresi</h3>
                  <p className="text-xs text-gray-500 mt-1">{categories.length} kategori</p>
                </div>
              </div>
              <button
                onClick={() => setShowCategoryFilter(false)}
                className="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Filter Options */}
            <div className="p-3 max-h-60 overflow-y-auto space-y-2 custom-scrollbar">
              <button
                onClick={() => {
                  setSelectedCategory('');
                  setShowCategoryFilter(false);
                }}
                className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 flex items-center justify-between ${
                  selectedCategory === '' 
                    ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md' 
                    : 'hover:bg-gray-50 text-gray-700 border border-gray-200 hover:border-blue-300'
                }`}
              >
                <div className="flex items-center space-x-3">
                  <div className={`w-2 h-2 rounded-full ${selectedCategory === '' ? 'bg-white' : 'bg-gray-400'}`} />
                  <span className="font-medium">Tüm Kategoriler</span>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  selectedCategory === '' 
                    ? 'bg-white bg-opacity-20 text-white' 
                    : 'bg-gray-100 text-gray-600'
                }`}>
                  {events.length}
                </span>
              </button>
              
              {categories.map((category) => {
                const categoryEvents = events.filter(event => 
                  event.category_id?._id === category._id || event.category_id === category._id
                );
                
                return (
                  <button
                    key={category._id}
                    onClick={() => {
                      setSelectedCategory(category._id);
                      setShowCategoryFilter(false);
                    }}
                    className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 flex items-center justify-between ${
                      selectedCategory === category._id 
                        ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md' 
                        : 'hover:bg-gray-50 text-gray-700 border border-gray-200 hover:border-blue-300'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <div 
                        className={`w-3 h-3 rounded-full shadow-sm ${
                          selectedCategory === category._id ? 'ring-2 ring-white' : ''
                        }`}
                        style={{ backgroundColor: category.color }}
                      />
                      <span className="font-medium">{category.name}</span>
                    </div>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      selectedCategory === category._id 
                        ? 'bg-white bg-opacity-20 text-white' 
                        : 'bg-gray-100 text-gray-600'
                    }`}>
                      {categoryEvents.length}
                    </span>
                  </button>
                );
              })}
            </div>
            
            {/* Clear Filter Button */}
            {selectedCategory && (
              <div className="p-3 border-t border-gray-100 bg-gray-50">
                <button
                  onClick={() => {
                    setSelectedCategory('');
                    setShowCategoryFilter(false);
                  }}
                  className="w-full px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors border border-gray-200 hover:border-gray-300 flex items-center justify-center space-x-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  <span>Filtreyi Temizle</span>
                </button>
              </div>
            )}
          </div>
        )}

        <p className="text-sm text-gray-600">
          Haritaya eklemek için bir olay seçin
        </p>
      </div>

      {/* Events List */}
      <div className="flex-1 overflow-y-auto space-y-2 min-h-0">
        {filteredEvents.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            {events.length === 0 ? 'Henüz olay eklenmemiş' : 'Olay bulunamadı'}
          </div>
        ) : (
          filteredEvents.map((event) => (
            <div
              key={event._id}
              onClick={() => onSelectEvent(selectedEvent?._id === event._id ? null : event)}
              className={`p-3 border-2 rounded-lg cursor-pointer transition-all ${
                selectedEvent?._id === event._id
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-start space-x-3">
                {/* Category Color Indicator */}
                {event.category_id?.color && (
                  <div
                    className="w-3 h-3 rounded-full flex-shrink-0 mt-1"
                    style={{ backgroundColor: event.category_id.color }}
                  />
                )}
                
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-gray-900 truncate">
                    {stripHtml(event.title)}
                  </h3>
                  
                  {event.category_id?.name && (
                    <p className="text-xs text-gray-500 mt-1">
                      {event.category_id.name}
                    </p>
                  )}
                  
                  {event.description && (
                    <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                      {stripHtml(event.description)}
                    </p>
                  )}
                  
                  {/* Event Date */}
                  {event.startDate && (
                    <p className="text-xs text-gray-500 mt-2">
                      {event.startDate.year && (
                        <>
                          {event.startDate.isBC ? 'MÖ ' : ''}
                          {event.startDate.year}
                        </>
                      )}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Selected Event Info */}
      {selectedEvent && (
        <div className="flex-shrink-0 mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm font-medium text-blue-800">
            Seçili Olay: {stripHtml(selectedEvent.title)}
          </p>
          <p className="text-xs text-blue-600 mt-1">
            Haritaya tıklayarak bu olayı yerleştirin
          </p>
        </div>
      )}
    </div>
  );
};

export default EventsMenu; 